import { render, staticRenderFns } from "./BlocoCompreende.vue?vue&type=template&id=127acad6&scoped=true&"
import script from "./BlocoCompreende.vue?vue&type=script&lang=js&"
export * from "./BlocoCompreende.vue?vue&type=script&lang=js&"
import style0 from "./BlocoCompreende.vue?vue&type=style&index=0&id=127acad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127acad6",
  null
  
)

export default component.exports